import axios from 'axios';

const API = axios.create({ baseURL: 'https://api.puzzleforge.io' });

// Attach JWT token to every request automatically
API.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ─── Auth ─────────────────────────────────────────────
export const register = (email, password) =>
  API.post('/auth/register', { email, password });

export const login = (email, password) => {
  const form = new FormData();
  form.append('username', email);
  form.append('password', password);
  return API.post('/auth/login', form);
};

export const getMe = () => API.get('/auth/me');

// ─── Puzzles ──────────────────────────────────────────
export const getTodayPuzzles = () => API.get('/puzzles/today');

export const getPuzzleByType = (type) =>
  API.get(`/puzzles/${type}/today`);

export const submitAttempt = (data) =>
  API.post('/puzzles/attempt', data);

export const getStats = () => API.get('/puzzles/stats');

// ─── Payments ─────────────────────────────────────────
export const getCheckoutUrl = () =>
  API.get('/payments/checkout-url');

export const getCredits = () => API.get('/credits/balance');


export const checkAttempt  = (puzzleId) => API.get(`/puzzles/check/${puzzleId}`);
export const skipPuzzle    = (puzzleId) => API.post(`/puzzles/skip/${puzzleId}`);

export const getNextPuzzle = (puzzleType) => API.post(`/credits/next/${puzzleType}`);

export const getPuzzleHistory = () => API.get('/puzzles/history');
export const getShareablePuzzle = (puzzleId) => API.get(`/puzzles/share/${puzzleId}`);

